// Lidský název řady pro nabídku dotažení (viz doc/plans/to-fill-human-labels.md, 2.3).
//
// Server (/api/ts_info) dá `info.label` hotový pro DAILY (má obs_type → zná granularitu).
// Pro SDATA/SEDATA server granularitu nezná (stype je jen v to_fill.params) → klient
// dolepí „— měsíční" / „— roční" z params.stype.
import { typFromEndpoint } from './tsTyp'

const GRAN_WORD = { MONTH: 'měsíční', YEAR: 'roční' }

// item = to_fill položka; info = ts_info řádek (nebo undefined)
export function tsLabel(item, info) {
  const base = info?.label || item?.params?.ts_id || item?.params?.gh_id || '?'
  const typ = typFromEndpoint(item?.endpoint)
  if ((typ === 'SDATA' || typ === 'SEDATA') && info?.label) {
    const g = GRAN_WORD[item?.params?.stype]
    return g ? `${base} — ${g}` : base
  }
  return base
}
